import { Injectable } from '@angular/core';
import { EBulkEditEventType, TBulkPointChanges } from 'react-lib/components/organisms/BulkEdit';
import { catchError, firstValueFrom, map, Observable, tap, throwError } from 'rxjs';
import { PromptService } from 'src/app/project/components/prompt/prompt.service';
import { translate } from 'src/app/project/features/translate/translate';
import { logEventInGTAG } from 'src/app/project/services/analytics/google-analytics';
import {
  EGoogleEventCategory,
  EGoogleEventSite,
} from 'src/app/project/services/analytics/google-analytics.consts';
import { SitePointFilterService } from '../../filters/site-point-filter.service';
import { PointsUpdateService } from '../points-update.service';
import { PointsService } from '../points.service';

@Injectable({
  providedIn: 'root',
})
export class BulkEditService {
  constructor(
    private pointsService: PointsService,
    private pointsUpdateService: PointsUpdateService,
    private promptService: PromptService,
    private sitePointFilterService: SitePointFilterService,
  ) {}

  save(
    changes: TBulkPointChanges,
    eventType: EBulkEditEventType,
    mentions: string[] = [],
  ): Promise<void> {
    const pointIds = this.pointsService.getSelectedPoints().map((point) => point._id);

    return firstValueFrom(
      this.pointsUpdateService.updatePoints(pointIds, changes, mentions).pipe(
        tap(() => this.handleSaved(eventType, pointIds.length)),
        catchError((error) => this.handleSaveError(error)),
        map(() => undefined),
      ),
    );
  }

  private handleSaved(eventType: EBulkEditEventType, numberOfPoints: number): void {
    logEventInGTAG(EGoogleEventSite.SITE__BULK_CHANGES__EDIT, {
      source: EGoogleEventCategory.SITE,
      type: eventType,
      count: numberOfPoints,
    });
    this.promptService.showSuccess(translate('prompt_points_update_success'));
    this.sitePointFilterService.filterPoints({ _keepScrollPosition: true });
  }

  private handleSaveError(error: unknown): Observable<never> {
    this.promptService.showError(translate('prompt_points_update_error'));

    return throwError(() => error);
  }
}
